import React, { useState } from "react";
import { Box, Paper } from "@material-ui/core";
import { ChatWidget, IntroText, Sheet, SheetContent } from "../../components";
import { ChatInitiateForm } from "./children";
import { useTranslation } from "react-i18next";

const Chat = () => {
  const { t } = useTranslation();
  const [participantDetails, setParticipantDetails] = useState();

  const handleInitiateChat = data => {
    setParticipantDetails(data);
  };

  return (
    <Sheet data-cy="view-doc-chat">
      <SheetContent>
        <Box mb={2}>
          {!participantDetails ? (
            <Paper>
              <Box p={2}>
                <IntroText>{t("chat.intro_text")}</IntroText>
                <ChatInitiateForm onInitiate={handleInitiateChat} />
              </Box>
            </Paper>
          ) : (
            <ChatWidget
              participantDetails={participantDetails}
              instanceId={process.env.REACT_APP_AMZ_CONNECT_INSTANCE_ID}
              contactFlowId={process.env.REACT_APP_AMZ_CONNECT_FLOW_ID}
            />
          )}
        </Box>
      </SheetContent>
    </Sheet>
  );
};

export { Chat };
